<template>
  <div v-loading="loading" class="page-wrap">
    <el-row>
      <el-col :xs="24" :sm="18" :lg="16">
        <el-form
          label-position="top"
          size="large"
          :model="form"
          :rules="rules"
          ref="formRef"
        >
          <el-row :gutter="20">
            <el-col :xs="24" :sm="18" :lg="16">
              <el-form-item label="Tashabbuslar doskasi" prop="board">
                <el-select
                  v-model="form.board"
                  style="width: 100%"
                  placeholder="Doskani tanlang"
                >
                  <el-option
                    v-for="board in boards"
                    :key="board.id"
                    :value="board.id"
                    :label="
                      board.title +
                      ' ' +
                      board.season +
                      '-' +
                      'mavsum ' +
                      board.year +
                      ' yil'
                    "
                  />
                </el-select>
              </el-form-item>
            </el-col>

            <el-col v-if="$store.state.role==='admin'" :xs="24" :sm="6" :lg="8">
              <el-button style="margin-top: 30px" type="warning" @click="onClickChronologyButton">
                Xronologiya ma'lumotlarini yangilash
              </el-button>
            </el-col>
            <el-col :xs="24" :sm="18" :lg="24" style="display: flex; gap: 10px; flex-wrap: wrap; margin-top: 5px">
              <el-button type="primary" @click="downloadFile">
                <img
                  src="@/assets/images/icons/download.svg"
                  alt=""
                />
                  Faylni yuklab oling
              </el-button>

              <el-button type="success" @click="downloadFinancialReport" style="margin-left: 0">
                <img
                  src="@/assets/images/icons/download.svg"
                  alt=""
                />
                  Moliyaviy hisobotni yuklab olish
              </el-button>
            </el-col>
          </el-row>
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { ElNotification } from "element-plus";

export default {
  name: "chronologyReports",
  data() {
    return {
      loading: false,
      boards: [],
      form: {
        board: null,
        file: [],
      },
      rules: {
        board: [
          { required: true, message: "Majburiy maydon!", trigger: "change" },
        ],
      },
    };
  },
  methods: {
    getBoardList() {
      this.$http
        .get("api/v1/boards",{params:{status:1}})
        .then(({ data }) => {
          this.boards = data.boards;
        })
        .catch(() => {});
    },
    downloadFinancialReport() {
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          this.loading = true;
          this.$http
            .get(`api/v1/initiatives-excel-financial`, {
              responseType: "blob",
              params: { board_id: this.form.board },
            })
            .then((res) => {
              const url = URL.createObjectURL(
                new Blob([res.data], {
                  type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
                })
              );
              const header = res.headers.get("Content-Disposition");
              let fileName = "moliyaviy-hisobot.xlsx";
              if (header) {
                const parts = header.split(";");
                if (parts[1]) fileName = parts[1].split("=")[1];
              }
              const link = document.createElement("a");
              link.href = url;
              link.setAttribute("download", fileName);
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
            })
            .catch(({ response }) => {
              ElNotification({
                title: "Ogohlantirish",
                message:
                  response?.data?.message ||
                  "Ma'lumot yuklashda xatolik sodir bo'ldi!",
                type: "warning",
              });
            })
            .finally(() => {
              this.loading = false;
            });
        }
      });
    },
    downloadFile() {
      this.$refs.formRef.validate((valid, fields) => {
        if (valid) {
          this.loading = true;
          this.$http
            .get(`api/v1/chron-statistics/excel`, {
              responseType: "blob",
              params: {
                board_id: this.form.board,
              },
            })
            .then((res) => {
              const url = URL.createObjectURL(
                new Blob([res.data], {
                  type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
                })
              );
              const header = res.headers.get("Content-Disposition");
              const parts = header.split(";");
              let fileName = parts[1].split("=")[1];
              const link = document.createElement("a");
              link.href = url;
              link.setAttribute("download", fileName);
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
            })
            .catch(({ response }) => {
              ElNotification({
                title: "Ogohlantirish",
                message:
                  response.data.message ||
                  "Ma'lumot yuklashda xatolik sodir bo'ldi!",
                type: "warning",
              });
            })
            .finally(() => {
              this.loading = false;
            });
        }
      });
    },
  },

  mounted() {
    this.getBoardList();
  },
};
</script>

<style scoped>
.page-wrap {
  padding: 20px;
}

.upload-demo {
  width: 100%;
}
</style>
